import React, { useRef, useState } from 'react'
import { button } from '@/components/atoms/Button/Button.css'
import { Icon } from '@/icons'

interface AudioButtonProps {
  /** 버튼 외부 크기(px) */
  size?: number
  /** 클릭 핸들러 */
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  /** 추가 클래스네임 */
  className?: string
  /** 오디오 파일 URL */
  audioSrc?: string | null
  /** 오디오 재생이 끝났을 때 콜백 */
  onAudioEnded?: () => void
}

/**
 * AudioButton 컴포넌트
 * - size prop으로 버튼 가로/세로 크기 조절
 * - Icon에 width/height를 반영
 * - audioSrc가 제공되면 음원 재생 기능 활성화
 */
export default function AudioButton({
  size = 36,
  onClick,
  className = '',
  audioSrc,
  onAudioEnded,
}: AudioButtonProps) {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    // 커스텀 onClick 핸들러가 있으면 실행
    if (onClick) {
      onClick(e);
    }

    // audioSrc가 있으면 음원 재생
    if (audioSrc && audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        setIsPlaying(false);
      } else {
        audioRef.current.play().catch(error => {
          console.error('오디오 재생 실패:', error);
        });
        setIsPlaying(true);
      }
    } else if (audioSrc) {
      console.warn('audioSrc는 있지만 audio element를 찾을 수 없습니다.');
    } else {
      console.log('audioSrc가 제공되지 않았습니다.');
    }
  };

  const handleAudioEnded = () => {
    setIsPlaying(false);
    onAudioEnded?.();
  };

  return (
    <>
      <button
        onClick={handleClick}
        className={`flex justify-center items-center p-1 rounded-full ${button} ${className}`}
        style={{
          width: size,
          height: size,
          background: 'linear-gradient(119deg, #ECEBFE 13.99%, #D8D6FF 86.01%)',
          opacity: isPlaying ? 0.7 : 1,
        }}
      >
        <div className='ml-1'>
          <Icon name="listen" width='100%' height='100%' />
        </div>
      </button>
      {audioSrc && (
        <audio 
          ref={audioRef} 
          src={audioSrc}
          onEnded={handleAudioEnded}
          style={{ display: 'none' }}
        />
      )}
    </>
  )
}